import {
  ChipAcceptedStyled,
  ChipDangerStyled,
  ChipPendingStyled,
} from './cv-video-status-chip.styled';
import {
  PlayIcon,
  ExclamationTriangleIcon,
  XCircleIcon,
} from '@heroicons/react/24/solid';
import { IconSize } from '@constants';
import CvVideoStatus from '@cv-videos/models/cv-video-status';

interface Props {
  label: string;
  status: CvVideoStatus;
  blurred?: boolean;
}

export const CvVideoStatusChip = ({
  label,
  status,
  blurred = false,
}: Props) => {
  switch (status) {
    case CvVideoStatus.PENDING:
    case CvVideoStatus.PROCESSING:
      return (
        <ChipPendingStyled>
          <ExclamationTriangleIcon width={IconSize.xs} height={IconSize.xs} />
          <span>{label}</span>
        </ChipPendingStyled>
      );
    case CvVideoStatus.REJECTED:
      return (
        <ChipDangerStyled attrs={{ blurred }}>
          <XCircleIcon width={IconSize.xs} height={IconSize.xs} />
          <span>{label}</span>
        </ChipDangerStyled>
      );
    case CvVideoStatus.ACCEPTED:
      return (
        <ChipAcceptedStyled>
          <PlayIcon width={IconSize.xs} height={IconSize.xs} />
          <span>{label}</span>
        </ChipAcceptedStyled>
      );

    default:
      return <ChipPendingStyled>{label}</ChipPendingStyled>;
  }
};
